// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import SpaClaim from '../../../claim/spa/state-connector';

const FullClaimDetails = props => {

    const title = <FormattedMessage id='CLAIM_DETAILS'/>;
    const body = (
        <SpaClaim
            location={{
                query: {
                    action: null
                }
            }}
            routeParams={{claimNumber: props.claimNumber}}
            tabm={true}
            tcsm={true}
        />
    );

    return (
        <Accordion
            accordionId='full-claim-details'
            body={body}
            isExpanded={true}
            title={title}
        />
    );

};

FullClaimDetails.displayName = 'FullClaimDetails';
FullClaimDetails.propTypes = {
    claimNumber: PropTypes.string.isRequired
};
export default FullClaimDetails;



// WEBPACK FOOTER //
// ./src/tabm/spa-details/components/full-claim-details.js